import { config } from '@/config';

export function getFeatureFlag<Scope extends keyof (typeof config)['feature']>(
  scope: Scope
) {
  return config.feature[scope];
}
